import React, { useMemo } from "react"
import { useVenue } from "@/contexts/venue"
import { useStore } from "@/store"

const TableGroupsHeader = () => {
  const { venue } = useVenue()
  const { selectedTableGroupIds, calendarDimensions } = useStore()

  const tableGroups = useMemo(
    () =>
      venue.tableGroups
        .filter((tableGroup) => !tableGroup.deleted && selectedTableGroupIds.includes(tableGroup.id))
        .map((tableGroup) => {
          const tables = venue.tables.filter((table) => !table.deleted && table.tableGroup.id === tableGroup.id)
          return {
            ...tableGroup,
            tables,
            labelWidth: calendarDimensions.columnWidth * tables.length,
          }
        }),
    [calendarDimensions.columnWidth, selectedTableGroupIds, venue.tableGroups, venue.tables],
  )
  return (
    <div
      style={{ height: calendarDimensions.tableGroupLabelHeight }}
      className="flex w-full min-w-min sticky top-0 z-30"
    >
      {tableGroups.map((tableGroup) => (
        <div
          key={tableGroup.id}
          style={{
            width: tableGroup.labelWidth,
          }}
          className={`flex text-center text-sm bg-gray-200 font-medium text-gray-500 border-0 border-r border-b border-solid border-gray-300 justify-center items-center`}
          data-testid={`panel-reservations-calendar-group-header-${tableGroup.id}`}
        >
          {tableGroup.name}
        </div>
      ))}
    </div>
  )
}

export default TableGroupsHeader
